<template>
  <div v-show="searchResultsAreLoading || categories.length > 0" id="CatalogSearch" class="catalog-search">
    <h2 class="catalog-search__header">Categories</h2>
    <div v-if="categories.length > 0" class="catalog-search__results">
      <b-row class="catalog-search__row">
        <b-col class="catalog-search__col">
          <loading-spinner v-show="searchResultsAreLoading" class="catalog-search__loading-spinner" />
          <h6 v-if="showEnterSearchTermMessage" class="catalog-search__enter-search-term-message">
            {{ getContentItem("pleaseEnterASearchTerm") }}
          </h6>
          <b-row v-show="!searchResultsAreLoading" class="catalog-search__results-row">
            <b-col
              v-for="category in categories"
              :key="category.Id"
              cols="6"
              sm="4"
              md="3"
              class="catalog-search__category-col"
            >
              <catalog-card
                :title="category.Title"
                :category-image-id="category.Image"
                :category-id="category.Id"
                class="catalog-search__catalog-card"
              />
            </b-col>
          </b-row>
          <b-row
            v-if="!searchResultsAreLoading && (categories == null || categories.length == 0)"
            class="catalog-search__no-results-row"
          >
            <em class="catalog-search__no-results-message">No categories match the search "{{ searchTerm }}".</em>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <loading-spinner v-show="searchResultsAreLoading" class="catalog-search__loading-spinner" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CatalogService } from "@/services/CatalogService";
import { ErrorLogService } from "@/services/ErrorLogService";
import LoadingSpinner from "@/components/Elements/LoadingSpinner";
import CatalogCard from "@/components/Elements/CatalogCard";
import CategoriesSideMenu from "@/components/SubMenus/CategoriesSideMenu";
import { brandAndRegionAuthHelper } from "@/components/mixins";

export default {
  components: {
    LoadingSpinner,
    CatalogCard,
  },
  mixins: [brandAndRegionAuthHelper],
  data: function () {
    return {
      categories: {},
      searchResultsAreLoading: true,
      showEnterSearchTermMessage: false,
    };
  },
  props: {
    searchTerm: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["user", "activeAccountId", "CatalogRoot", "getContentItem", "audienceIds"]),
  },
  created() {
    this.searchTerm = this.$route.query.searchTerm || "";
    if (this.searchTerm != "") {
      this.GetCategories();
    } else {
      this.searchResultsAreLoading = false;
      this.showEnterSearchTermMessage = true;
    }
  },
  methods: {
    GetCategories() {
      this.searchResultsAreLoading = true;
      //here1
      CatalogService.GetCategoriesByKeyword(this.activeAccountId, this.user.UserId, this.searchTerm, this.audienceIds)
        .then((result) => {
          var cats = result.data;
          var authorizedCats = cats.filter((x) => this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth));
          this.categories = authorizedCats;
        })
        .catch((err) => {
          ErrorLogService.LogException(err);
        })
        .finally(() => {
          this.searchResultsAreLoading = false;
        });
    },
    GetCategoryImage(imageId) {
      return CatalogService.GetMediaUrl(imageId);
    },
  },
};
</script>

<style lang="scss">
.catalog-search {
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  height: 100%;
  flex: 1;
}
.catalog-search__results{
  margin-top: 1rem;
  height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.catalog-search__category-col{
  align-content: end;
}

.catalog-search__header {
  font-size: 20px;
  border-bottom: 0.1px solid lightgray;
}

.catalog-search-header__title {
  margin: 16px;
  @media (min-width: $screen-sm-min) {
    margin: initial;
  }
}
.catalog-search-no-results-message {
  padding: 0 24px;
}
@media (max-width: 1200px) {
  .catalog-search {
    width: 85vw;
  }
}
</style>